import { gql } from '@apollo/client'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { useSelectedPerspective } from '../../../_shared/PerspectiveDropdown'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrdersByStatusState = () => React.useContext(Context)
export const useServiceOrdersByStatus = () => useServiceOrdersByStatusState()?.serviceOrdersVolumeByStatus

const QUERY = gql`
  query ServiceOrdersVolumeByStatus($filter: ServiceOrdersVolumeByStatusFilter) {
    serviceOrdersVolumeByStatus(filter: $filter) {
      openCount
      completedCount
      discontinuedCount
      date
    }
  }
`

const ServiceOrdersByStatusLoader = ({ children }) => {
  const filter = useCleanFilterForRequest() || {}
  const perspective = useSelectedPerspective()

  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { perspective: perspective?.id, ...filter } },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersByStatusLoader
